export const ISSUE_ATTRIBUTE_NAMES = {
  TITLE: 'title',
  CUSTOM_IDENTIFIER: 'customIdentifier',
  SUGGESTED_ANSWER: 'suggestedAnswer',
  STATUS: 'status',
  ASSIGNED_TO: 'assignedTo',
  DUE_DATE: 'dueDate',
  LOCATION_DESCRIPTION: 'locationDescription',
  TRANSITION_ID: 'transitionId',
  ANSWER: 'answer',
  OFFICIAL_RESPONSE: 'officialResponse', // v2 name of answer
  COMMENTS_ATTRIBUTES: 'commentsAttributes',
  CO_REVIEWERS: 'coReviewers',
  WATCHERS: 'watchers',
  ATTACHMENT: 'attachment',
  COMMENT: 'body',
  DELETED_AT: 'deletedAt',
  HIDDEN_DOC_VERSION: 'hiddenDocVersion',
  COST: 'costImpact',
  SCHEDULE: 'scheduleImpact',
  PRIORITY: 'priority',
  DISCIPLINE: 'discipline',
  CATEGORY: 'category',
  SUB_ID: 'reference',
  QUESTION: 'question',
  LINKED_ENTITIES: 'linkedEntities',
  LOCATION_IDS: 'locations',
  RFI_TYPE_ID: 'rfiTypeId',
} as const;

export type RfiFieldName = (typeof ISSUE_ATTRIBUTE_NAMES)[keyof typeof ISSUE_ATTRIBUTE_NAMES]; // e.g - 'title' | 'customIdentifier' ...
